import React from 'react';

import NotFoundInfo from '../../components/no-auth/info/NotFoundInfo';
import ReqAndMoneyInfo from '../../components/no-auth/info/ReqAndMoneyInfo';
import { useExtra } from '../../hooks/selectors';

const RouterForInfoPage = () => {
    const extra = useExtra();

    return extra.strapiApi?.status === 'success' ? <ReqAndMoneyInfo extra={extra.strapiApi} /> : <NotFoundInfo />;
};

export default RouterForInfoPage;
